'use strict';

var util = require('../../util');
var shipping = require('./shipping');

/**
 * @function
 * @description Selects the first address from the list of addresses
 */
exports.init = function () {

    function setNewAddress($form) {
        // set the selected address to empty
        $('select[name$="_addressList"]', $form).val('');
        // clear the address fields
        let $addressID = $('input[name$="_savedaddressid"]', $form);
        $addressID.val('new-address');
        let addressFields = $('.checkout-address-fields .c-form-row__input', $form);
        addressFields.each(function () {
            $(this).val('');
        });
        $form.addClass('address--edit');
    }


    var $form = $('form.address');
    // select address from list
    var $addressList = $('select[name$="_addressList"]', $form);
    $addressList.on('change', function () {
        let $selected = $(this).children(':selected').first();
        let selectedAddress = $($selected).data('address');
        if (!selectedAddress) { 
            let $addressID = $('input[name$="_savedaddressid"]', $form);
            if ($addressID.length) {
                setNewAddress($form);
            }
            return;
        }
        util.fillAddressFields(selectedAddress, $form);
        shipping.updateShippingMethodList();
        // re-validate the form
        let addressValidationResult = true;
        if ($form.data("validator")) {
            // Get the original ignore setting to restore it later (we are using an older version of jQuery Validate that does not support passing ignore as an option)
            let originalIgnore = $form.data("validator").settings.ignore;
            // set validation to only checkout address fields (including hidden ones)
            $form.data("validator").settings.ignore = ":not(.checkout-address-fields input, .checkout-address-fields select, .checkout-address-fields textarea)";
            addressValidationResult = $form.validate().form();
            // restore original ignore setting
            $form.data("validator").settings.ignore = originalIgnore;
        }
        if (!addressValidationResult) {
            // if the form is not valid, open up edit mode so that the error is visible
            $form.addClass('address--edit');
        }
    });
    $('.js-update-address', $form).on('click', function () {
        $form.addClass('address--edit');
    });
    $('.js-add-address', $form).on('click', function () {
        setNewAddress($form);
    });

    // Initially select the first address if available
    if ($addressList.length && $addressList.children().length > 1) {
        let $selected = $addressList.children(':selected').first();
        if (!$selected.length || !$selected.data('address')) {
            // select the first address that has data
            let $newSelected = null;

            let $addressID = $('input[name$="_savedaddressid"]', $form);
            let selectedID = null;
            if ($addressID.length) {
                selectedID = $addressID.val();
            }
            let $addressListChildren = $addressList.children();
            for (let i = 0; i < $addressListChildren.length; i++) {
                let option = $addressListChildren[i];
                if (i === ($addressListChildren.length - 1)) {
                    // if we are at the last option, select it
                    $newSelected = $(option);
                    break;
                }
                if ($(option).data('address')) {
                    if (selectedID) {
                        let addressData = $(option).data('address');
                        if (addressData && typeof addressData === 'object' && addressData.ID === selectedID) {
                            $newSelected = $(option);
                            break;
                        }
                    } else {
                        $newSelected = $(option);
                        break;
                    }
                }
            }
            if ($newSelected) {
                $selected.prop("selected", false);
                $newSelected.prop("selected", true);
                $addressList.trigger('change');
            }
        }
    }

};
